module.exports = __webpack_public_path__ + "static/media/JaysonStreet.76d5e89d.jpg";